/* unplugin-vue-components disabled */import script from "./team-member.vue?vue&type=script&setup=true&lang=js"
export * from "./team-member.vue?vue&type=script&setup=true&lang=js"

import "./team-member.vue?vue&type=style&index=0&id=8c16f0ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c16f0ca"]])

export default __exports__